// ========== Fade-In on Page Load ==========
window.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.body.classList.remove('opacity-0');
    document.body.classList.add('opacity-100');
  }, 50);
});

// ========== Smooth Page Transitions ==========
document.querySelectorAll('a[href]').forEach(link => {
  const url = new URL(link.href);
  const isInternal = url.origin === window.location.origin;

  if (isInternal && !link.target && !link.href.includes('#') && !link.hasAttribute('download')) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.body.classList.remove('opacity-100');
      document.body.classList.add('opacity-0');

      setTimeout(() => {
        window.location.href = link.href;
      }, 700);
    });
  }
});

// ========== IntersectionObserver Animation ==========
window.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('opacity-100', 'translate-y-0', 'rotate-0');
        entry.target.classList.remove(
          'opacity-0',
          'translate-y-10',
          'rotate-3',
          '-rotate-3',
          'rotate-6'
        );
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15
  });

  ['#footer-bar', '#footer-left', '#footer-right', '.step-box'].forEach(selector => {
    document.querySelectorAll(selector).forEach(el => observer.observe(el));
  });
});


// ========== Mobile Menu ==========
window.toggleMobileMenu = function () {
  const burger = document.getElementById('burger-button');
  const mobileMenu = document.getElementById('mobile-menu');

  burger.classList.toggle('open');
  mobileMenu.classList.toggle('hidden');
};

// Schließen, wenn man außerhalb klickt
document.addEventListener('click', function (event) {
  const burger = document.getElementById('burger-button');
  const mobileMenu = document.getElementById('mobile-menu');
  const isClickInside = burger.contains(event.target) || mobileMenu.contains(event.target);

  if (!isClickInside) {
    mobileMenu.classList.add('hidden');
    burger.classList.remove('open');
  }
});

// Manuelles Event binden (falls nötig)
document.getElementById('burger-button')?.addEventListener('click', function (e) {
  e.stopPropagation();
  toggleMobileMenu();
});

// ========== Smooth Scroll to Anchor ==========
document.addEventListener('click', function (e) {
  if (e.target.matches('a[href^="#"]')) {
    e.preventDefault();
    const targetId = e.target.getAttribute('href');
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }
});

// ========== Contact Form Handler ==========
document.addEventListener('DOMContentLoaded', function () {
  ['contact-form-index', 'contact-form', 'contact-form-component'].forEach(id => {
    const form = document.getElementById(id);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        const formData = new FormData(this);
        const name = formData.get('name');
        const email = formData.get('email');
        const message = formData.get('message');

        if (!name || !email || !message) {
          alert('Bitte füllen Sie alle Pflichtfelder aus.');
          return;
        }

        alert('Vielen Dank für Ihre Nachricht! Ich melde mich bald bei Ihnen.');
        this.reset();
      });
    }
  });
});

// ========== FAQ Accordion ==========
document.addEventListener('DOMContentLoaded', function () {
  const accordionItems = document.querySelectorAll('.accordion-item');

  accordionItems.forEach(item => {
    item.addEventListener('click', function (e) {
      e.stopPropagation();
      const content = this.querySelector('.accordion-content');
      const chevron = this.querySelector('.accordion-chevron');
      const isExpanded = content.classList.contains('expanded');

      content.classList.toggle('expanded', !isExpanded);
      this.classList.toggle('expanded', !isExpanded);
      if (chevron) {
        chevron.classList.toggle('rotate-180', !isExpanded);
      }
    });
  });
});

